import { render } from "./Vehicles.vue?vue&type=template&id=5e85eaa0"
import script from "./Vehicles.vue?vue&type=script&lang=js"
export * from "./Vehicles.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./Vehicles.vue?vue&type=style&index=0&id=5e85eaa0&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script